import angular from 'angular';
import moment from 'moment';
import isEmpty from 'lodash/isEmpty';

import * as actions from '../../../store/actions';

const mapStateToScope = (state) => ({
  user: state.user.user,
  userAttributes: state.user.userAttributes,
  subComponent: state.statsbar.activeComponent,
});

angular
  .module('myConsultApp')
  .controller('userEditController', ($ngRedux, $scope, $rootScope, $http, ENV, $timeout) => {
    $scope.userEditDialogOptions = {
      heading: 'Warning!',
      message:
        'You have unsaved changes on this tab! Press OK to continue (undo changes), or Cancel to stay on the current tab and continue editing.',
      buttons: [
        {
          label: 'OK',
          href: '#',
          clickFn: () => {
            $scope.isFormDataChanged = false;
          },
        },
        {
          label: 'Cancel',
          href: '#',
          clickFn: () => {
            $scope.isFormDataChanged = false;
          },
        },
      ],
    };
    $scope.communicationErrorDialogOptions = {
      heading: 'Error',
      message:
        'The request for user communication preferences either failed or is taking too long.  Please refresh the page and try again',
      buttons: [
        {
          label: 'Close',
          href: '#',
          clickFn: () => {
            $scope.showCommunicationErrorDialog = false;
            $scope.isCommunicationErrorTimerRunning = false;
          },
        },
      ],
    };
    $scope.isCommunicationErrorTimerRunning = false;
    $scope.showCommunicationErrorDialog = false;
    $scope.user_update_success = null;
    $scope.communication_update_success = null;
    $scope.loyalty_update_success = null;
    $scope.isFixedUserFields = false;
    $scope.initValues = () => {
      $scope.setUserAttributeHasValidAddress(true);
      $scope.setUserAttributeHasBeenValidated(false);
      $scope.isFormDataChanged = false;
      $scope.isRequestSuccess = false;
      $scope.showValidateAddress = false;
      $scope.isValidateAddressError = false;
      $scope.correctedAddress = null;
      $scope.validateAddress = null;
      $scope.userInfo = {
        users: {
          first_name: $scope.user?.first_name || '',
          last_name: $scope.user?.last_name || '',
          contact_information: {
            email: $scope.user?.contact_information?.email || '',
            email_verified: Boolean($scope.user?.contact_information?.email_verified) || 0,
            mobile_phone: $scope.user?.contact_information?.mobile_phone || '',
          },
          address_information: {
            address_1: $scope.user?.address_information?.address_1 || '',
            address_2: $scope.user?.address_information?.address_2 || '',
            city: $scope.user?.address_information?.city || '',
            state: $scope.user?.address_information?.state || '',
            zip: $scope.user?.address_information?.zip || '',
            country: $scope.user?.address_information?.country || '',
          },
        },
      };
      $scope.isUserReady = true;
      $scope.sampleUserInfo = angular.copy($scope.userInfo);
      $scope.emailVerification = [
        { name: 'Not Verified', value: 0 },
        { name: 'Verified', value: 1 },
      ];
      $scope.country = { name: '', abbreviation: '' };
      $scope.state = { name: '', abbreviation: '' };
      $scope.countries = [];
      $scope.states = [];
      $scope.filteredStates = [];
      $scope.communication = [];
      $scope.userCommunication = [];
      $scope.identityErrors = {};
      $scope.communicationErrors = {};
      $scope.preferencesErrors = null;
      $scope.processing_update_user = false;
      if ($scope.tabId !== 'user-information') {
        $scope.tabId = 'user_information';
        $scope.userEditTabChanges($scope.tabId, 0);
      }
      $scope.isCommunicationSaveDisabled = false;
      $scope.isSubmitUserDataDisabled = true;
    };

    $scope.init = () => {
      $scope.unsubscribe = $ngRedux.connect(mapStateToScope, actions)($scope);
    };

    $scope.getInfo = async () => {
      // set timer to check if SFMC request is taking too long and show dialog if so
      $scope.isCommunicationErrorTimerRunning = true;
      $timeout(() => {
        if ($scope.isCommunicationErrorTimerRunning === true) {
          $scope.showCommunicationErrorDialog = true;
        }
      }, 20000);
      await $scope.getStates($http, ENV).then((res) => {
        $timeout(() => {
          $scope.states = res;
          if (!isEmpty($scope.user)) {
            $scope.state = $scope.states.filter(
              (state) => state.abbreviation === $scope.user.address_information.state,
            )[0];
          }
        });
      });
      $scope.getCountries($http, ENV).then((res) => {
        $timeout(() => {
          $scope.countries = res.filter((country) => ['US', 'CA'].includes(country.abbreviation));
          if (!isEmpty($scope.user)) {
            $scope.country = $scope.countries.filter(
              (country) => country.abbreviation === $scope.user.address_information.country,
            )[0];
          }
        });
      });
      $scope
        .getCommunication($http, ENV, $scope.user.id)
        .then((res) => {
          $timeout(() => {
            $scope.isCommunicationErrorTimerRunning = false;
            $scope.communication = res;
            angular.forEach($scope.communication, (comm_category, key) => {
              if (!comm_category.category_settings.communication_setting) {
                angular.forEach($scope.communication[key].subcategories, (subcategory, subkey) => {
                  $scope.communication[key].subcategories[subkey].subcategory_settings.communication_preference = 'neither';
                  $scope.communication[key].subcategories[subkey].subcategory_settings.communication_setting = false;
                });
              }
            });
            $scope.userCommunication = angular.copy($scope.communication);
          });
        })
        .catch((error) => {
          // show SFMC request error dialog if error thrown
          $scope.showCommunicationErrorDialog = true;
        });
    };

    $scope.unsubscribeCategory = (category) => {
      $scope.preferencesErrors = null;
      angular.forEach($scope.userCommunication, (comm_category, key) => {
        if (comm_category.category_slug == category.category_slug) {
          $scope.userCommunication[key].category_settings.communication_setting = false;
          angular.forEach($scope.userCommunication[key].subcategories, (subcategory, subkey) => {
            $scope.userCommunication[key].subcategories[subkey].subcategory_settings.communication_preference = 'neither';
            $scope.userCommunication[key].subcategories[subkey].subcategory_settings.communication_setting = false;
          });
        }
      });
    };

    $scope.unsubscribeSubcategory = (subcategory, category) => {
      $scope.preferencesErrors = null;
      angular.forEach($scope.userCommunication, (comm_category, key) => {
        if (comm_category.category_slug == category.category_slug) {
          angular.forEach($scope.userCommunication[key].subcategories, (comm_subcategory, subkey) => {
            if (comm_subcategory.subcategory_slug === subcategory.subcategory_slug) {
              $scope.userCommunication[key].subcategories[subkey].subcategory_settings.communication_preference = 'neither';
              $scope.userCommunication[key].subcategories[subkey].subcategory_settings.communication_setting = false;
            }
          });
        }
      });
    };

    $scope.subscribeCategory = (category) => {
      $scope.preferencesErrors = null;
      angular.forEach($scope.userCommunication, (comm_category, key) => {
        if (comm_category.category_slug == category.category_slug) {
          $scope.userCommunication[key].category_settings.communication_setting = true;
          angular.forEach($scope.userCommunication[key].subcategories, (subcategory, subkey) => {
            $scope.userCommunication[key].subcategories[subkey].subcategory_settings.communication_preference = subcategory.default_subcategory_settings.communication_preference;
            $scope.userCommunication[key].subcategories[subkey].subcategory_settings.communication_setting = subcategory.default_subcategory_settings.communication_setting;
          });
        }
      });
    };

    $scope.subscribeSubcategory = (subcategory, category) => {
      $scope.preferencesErrors = null;
      angular.forEach($scope.userCommunication, (comm_category, key) => {
        if (comm_category.category_slug == category.category_slug) {
          angular.forEach($scope.userCommunication[key].subcategories, (comm_subcategory, subkey) => {
            if (comm_subcategory.subcategory_slug == subcategory.subcategory_slug) {
              $scope.userCommunication[key].subcategories[subkey].subcategory_settings.communication_preference = subcategory.default_subcategory_settings.communication_preference;
              $scope.userCommunication[key].subcategories[subkey].subcategory_settings.communication_setting = true;
            }
          });
        }
      });
    };


    $scope.toggleEmail = (subcategory, category) => {
      $scope.preferencesErrors = null;
      var oldpreference = subcategory.subcategory_settings.communication_preference;
      var newpreference = subcategory.subcategory_settings.communication_preference;
      if (oldpreference === 'neither') {
        newpreference = 'email';
      } else if (oldpreference === 'both') {
        newpreference = 'sms';
      } else if (oldpreference === 'email') {
        newpreference = 'neither';
      } else if (oldpreference === 'sms') {
        newpreference = 'both';
      }
      angular.forEach($scope.userCommunication, (comm_category, key) => {
        if (comm_category.category_slug == category.category_slug) {
          angular.forEach($scope.userCommunication[key].subcategories, (comm_subcategory, subkey) => {
            if (comm_subcategory.subcategory_slug == subcategory.subcategory_slug) {
              $scope.userCommunication[key].subcategories[subkey].subcategory_settings.communication_preference = newpreference;
            }
          });
        }
      });
    };

    $scope.toggleSMS = (subcategory, category) => {
      $scope.preferencesErrors = null;
      var oldpreference = subcategory.subcategory_settings.communication_preference;
      var newpreference = subcategory.subcategory_settings.communication_preference;
      if (oldpreference === 'neither') {
        newpreference = 'sms';
      } else if (oldpreference === 'both') {
        newpreference = 'email';
      } else if (oldpreference === 'sms') {
        newpreference = 'neither';
      } else if (oldpreference === 'email') {
        newpreference = 'both';
      }
      angular.forEach($scope.userCommunication, (comm_category, key) => {
        if (comm_category.category_slug == category.category_slug) {
          angular.forEach($scope.userCommunication[key].subcategories, (comm_subcategory, subkey) => {
            if (comm_subcategory.subcategory_slug == subcategory.subcategory_slug) {
              $scope.userCommunication[key].subcategories[subkey].subcategory_settings.communication_preference = newpreference;
            }
          });
        }
      });
    };

    $scope.filterStates = (states) => {
      if ($scope.country !== undefined) {
        const code = $scope.country.abbreviation === 'CA' ? 31 : 184;

        return states.filter((state) => state.country === code);
      } else {
        return states;
      }
    };

    $scope.searchState = (query) => {
      return new Promise((resolve, reject) => {
        if ($scope.filteredStates && $scope.filteredStates.length > 0) {
          const payload = $scope.filteredStates.filter((state) =>
            state.name.toLowerCase().includes(query.toLowerCase()),
          );
          resolve({ states: payload });
        } else {
          reject({
            state: 'Not Found',
          });
        }
      });
    };

    $scope.selectState = (option) => {
      $scope.state = option;
      if (option.abbreviation == undefined || option.abbreviation == '') {
        $scope.userInfo.users.address_information.state = '';
      } else {
        $scope.userInfo.users.address_information.state = option.abbreviation;
        let countryAbbreviation = option.country === 31 ? 'CA' : 'US';
        if (countryAbbreviation != $scope.userInfo.users.address_information.country) {
          $scope.selectCountry(
            $scope.countries.filter((country) => country.abbreviation === countryAbbreviation)[0],
          );
        }
      }
      $scope.triggerInput('state-search', $scope.state.name);
    };

    $scope.selectCountry = (option) => {
      $scope.country = option;
      if (option.abbreviation == undefined) {
        $scope.userInfo.users.address_information.country = '';
      } else {
        $scope.userInfo.users.address_information.country = option.abbreviation;
      }
    };

    $scope.setUserProcessing = (item) => {
      $scope.isUserReady = item;
    };

    $scope.cancelAddressValidation = () => {
      $scope.showValidateAddress = false;
      $scope.isValidateAddressError = false;
      $scope.correctedAddress = null;
      $scope.validateAddress = null;
    };

    // wrapper function to catch promise rejections from template that can be ignored
    $scope.updateUserInfoWrapper = (
      showSuccessMessage = true,
      isValidatingAddress,
      useCorrectedAddress,
    ) => {
      $scope
        .updateUserInfo(showSuccessMessage, isValidatingAddress, useCorrectedAddress)
        .catch((error) => {
          console.log(error);
        });
    };

    $scope.updateUserInfo = (showSuccessMessage = true, isValidatingAddress, useCorrectedAddress) =>
      new Promise((resolve, reject) => {
        if (showSuccessMessage === true) {
          $scope.processing_update_user = true;
        }

        const stateElement = document.getElementById('state-search_value');

        if (stateElement && stateElement.value === '') {
          $scope.userInfo.users.address_information.state = '';
        }

        $scope
          .updateUser($http, ENV, $scope.user.id, {
            users: {
              ...$scope.userInfo.users,
              ...(useCorrectedAddress && $scope.correctedAddress
                ? { address_information: { ...$scope.userInfo.users.address_information, ...$scope.correctedAddress } }
                : {}),
              usps_validate: isValidatingAddress || false,
            },
          })
          .then(() => {
            $scope.sampleUserInfo = angular.copy($scope.userInfo);
            $scope.getUser($http, ENV, $scope.user.id);
            $scope.showValidateAddress = false;
            $scope.correctedAddress = null;
            $scope.isValidateAddressError = false;
            $scope.validateAddress = null;
            $timeout(() => {
              $scope.setUserAttributeHasValidAddress(true);
              $scope.setUserAttributeHasBeenValidated(true);
              if (showSuccessMessage === true) {
                $scope.processing_update_user = false;
                $scope.user_update_success = 'Successfully Updated';
                $('.user-edit-container').animate({ scrollTop: 0 });
                setTimeout(() => {
                  $timeout(() => {
                    $scope.user_update_success = null;
                  });
                }, 5000);
              } else {
                resolve(true);
              }
              $scope.identityErrors = {};
              return true;
            });
          })
          .catch((error) => {
            $scope.showValidateAddress =
              isValidatingAddress && !!error?.data?.users?.address_information?.corrected_address;

            $timeout(() => {
              $scope.setUserAttributeHasValidAddress(false);
              $scope.setUserAttributeHasBeenValidated(false);
              if ($scope.showValidateAddress) {
                $scope.processing_update_user = false;
                $scope.correctedAddress = error?.data?.users?.address_information?.corrected_address;
                $scope.isValidateAddressError = error?.data?.users?.address_information?.corrected_address?.error;
                return;
              }
              // show profile validation errors
              if (showSuccessMessage === true) {
                $scope.processing_update_user = false;
                $scope.identityErrors = $scope.processErrors(error.data, 'users');
              } else {
                $scope.processing_update_user = false;
                $scope.communicationErrors = $scope.processErrors(error.data, 'users');
              }
            });
            reject();
            return false;
          });
      });

    $scope.getUTCToLocalDateTime = function (date, format) {
      var dateUtc = moment.utc(date);
      var localDate = moment(dateUtc).local();
      return localDate.format(format);
    };

    $scope.updateCommunicationSettings = async () => {
      $scope.processing_update_user = true;
      var user_updated = true;
      if (!angular.equals($scope.sampleUserInfo, $scope.userInfo)) {
        try {
          user_updated = await $scope.updateUserInfo(false);
        } catch {
          user_updated = false;
          $scope.processing_update_user = false;
        }
      }
      if (!user_updated) {
        $scope.processing_update_user = false;
        return;
      }
      $scope.preferencesErrors = null;
      angular.forEach($scope.userCommunication, (value, key) => {
        if (value.category_settings.communication_setting) {
          angular.forEach($scope.userCommunication[key].subcategories, (comm_subcategory, subkey) => {
            if(comm_subcategory.subcategory_settings.communication_setting && comm_subcategory.subcategory_settings.communication_preference == 'neither') {
              $scope.preferencesErrors = 'You cannot subscribe to a communication preference and not select a communication method.';
            }
            if ($scope.preferencesErrors) {
              $scope.processing_update_user = false;
              return;
            }
          });
        }
      });
      if ($scope.preferencesErrors) {  
        $scope.processing_update_user = false;
        return;
      }
      if (!angular.equals($scope.communication, $scope.userCommunication)) {
        var communicationsUpdate = [];
        angular.forEach($scope.userCommunication, (value, key) => {
          communicationsUpdate.push({
            category_slug: value.category_slug,
            category_settings: value.category_settings,
          });
          if (value.category_settings.communication_setting) {
            communicationsUpdate[key].subcategories = [];
            angular.forEach($scope.userCommunication[key].subcategories, (comm_subcategory, subkey) => {
              if (comm_subcategory.subcategory_settings.communication_setting) {
                communicationsUpdate[key].subcategories.push({
                    subcategory_slug: comm_subcategory.subcategory_slug,
                    subcategory_settings: comm_subcategory.subcategory_settings,
                });
              } else if (!comm_subcategory.subcategory_settings.communication_setting) {
                communicationsUpdate[key].subcategories.push({
                  subcategory_slug: comm_subcategory.subcategory_slug,
                  subcategory_settings: {
                    communication_setting: false,
                    communication_preference: 'neither',
                  },
                });
              }
            });
          }
        });
        $scope
          .saveCommunication($http, ENV, $scope.user.id, communicationsUpdate)
          .then((res) => {
            $timeout(() => {
              $scope.processing_update_user = false;
              $scope.communication = res;
              $scope.communication_update_success = 'Successfully Updated';
              $scope.userCommunication = angular.copy($scope.communication);
              $('.user-edit-container').animate({ scrollTop: 0 });
              setTimeout(() => {
                $timeout(() => {
                  $scope.communication_update_success = null;
                });
              }, 5000);
            });
          })
          .catch((error) => {
            $timeout(() => {
              $scope.processing_update_user = false;
              $scope.preferencesErrors = $scope.processErrors(error.data, 'communication');
            });
          });
      } else {
        $scope.processing_update_user = false;
        $scope.communication_update_success = 'Successfully Updated';
        setTimeout(() => {
          $timeout(() => {
            $scope.communication_update_success = null;
          });
        }, 5000);
        $('.user-edit-container').animate({ scrollTop: 0 });
      }
    };

    $scope.userEditTabChanges = (tabId, position) => {
      if ($scope.subComponent !== 'edit-user-profile') {
        return;
      }
      $scope.attemptedTabChange = tabId ?? $scope.attemptedTabChange;
      $scope.attemptedPosition = position ?? $scope.attemptedPosition;

      if (!angular.equals($scope.sampleUserInfo, $scope.userInfo)) {
        $scope.userEditDialogOptions.buttons[0].clickFn = () => {
          $scope.userInfo = angular.copy($scope.sampleUserInfo);
          $scope.state = $scope.states.filter(
            (state) => state.abbreviation === $scope.userInfo.users.address_information.state,
          )[0];
          $scope.triggerInput('state-search', $scope.state.name);
          $scope.country = $scope.countries.filter(
            (country) => country.abbreviation === $scope.userInfo.users.address_information.country,
          )[0];
          $scope.isFormDataChanged = false;
          $scope.identityErrors = {};
          $scope.userEditTabChanges();
        };
        $scope.isFormDataChanged = true;
        return;
      }

      if (!angular.equals($scope.userCommunication, $scope.communication)) {
        $scope.userEditDialogOptions.buttons[0].clickFn = () => {
          $scope.userCommunication = angular.copy($scope.communication);
          $scope.isFormDataChanged = false;
          $scope.communicationErrors = {};
          $scope.preferencesErrors = null;
          $scope.userEditTabChanges();
        };
        $scope.isFormDataChanged = true;
        return;
      }

      if (!$scope.isFormDataChanged) {
        const indicator = document.querySelector('.user-edit .indicator');
        const tabs = document.querySelectorAll('.user-edit .tab');

        if (indicator) {
          indicator.style.marginLeft = `${$scope.attemptedPosition * tabs[0].offsetWidth}px`;
          indicator.style.width = tabs[0].offsetWidth ? `${tabs[0].offsetWidth}px` : `198px`;
        }

        $scope.tabId = $scope.attemptedTabChange;
        $scope.identityErrors = {};
        $scope.communicationErrors = {};
        $scope.preferencesErrors = null;
      }

      if ($scope.attemptedTabChange === 'user_information') {
        $timeout(() => {
          $scope.triggerInput('state-search', $scope.state.name);
        }, 500);
      }
    };

    $scope.processErrors = (error, key) => {
      const errors = {};

      Object.keys(error[key]).map((item) => {
        const value = error[key][item];
        if (Array.isArray(value)) {
          errors[item] = value;
        } else if (typeof value === 'object') {
          // Flatten nested sub-objects (contact_information, address_information)
          Object.keys(value).map((subItem) => {
            if (Array.isArray(value[subItem])) {
              errors[subItem] = value[subItem];
            } else if (typeof value[subItem] === 'object') {
              errors[subItem] = Object.values(value[subItem]);
            } else {
              errors[subItem] = [value[subItem]];
            }
          });
        } else {
          errors[item] = [value];
        }
      });

      if (errors.error) {
        errors.email = errors.error;
        delete errors.error;
      }

      return errors;
    };

    $scope.blurState = () => {
      $scope.selectState($scope.state);
    };

    const componentListener = $scope.$watch('subComponent', (newValue, oldValue) => {
      if (newValue === 'edit-user-profile') {
        $scope.initValues();
        $scope.getInfo();
      }
    });

    const userListener = $scope.$watch('user', () => {
      if (!isEmpty($scope.user)) {
        $scope.userInfo = {
          users: {
            first_name: $scope.user?.first_name || '',
            last_name: $scope.user?.last_name || '',
            contact_information: {
              email: $scope.user?.contact_information?.email || '',
              email_verified: Boolean($scope.user?.contact_information?.email_verified) || 0,
              mobile_phone: $scope.user?.contact_information?.mobile_phone || '',
            },
            address_information: {
              address_1: $scope.user?.address_information?.address_1 || '',
              address_2: $scope.user?.address_information?.address_2 || '',
              city: $scope.user?.address_information?.city || '',
              state: $scope.user?.address_information?.state || '',
              zip: $scope.user?.address_information?.zip || '',
              country: $scope.user?.address_information?.country || '',
            },
          },
        };
        $scope.sampleUserInfo = angular.copy($scope.userInfo);
        $scope.isCommunicationSaveDisabled =
          angular.equals($scope.communication, $scope.userCommunication) &&
          angular.equals($scope.sampleUserInfo, $scope.userInfo);
        $scope.isSubmitUserDataDisabled = angular.equals($scope.sampleUserInfo, $scope.userInfo);
      }
    });

    const countryListener = $scope.$watch('country', () => {
      $scope.filteredStates = $scope.filterStates($scope.states);
      if (!$scope.states.length) return;
      if ($scope.filteredStates == undefined || !$scope.filteredStates.includes($scope.state)) {
        $scope.selectState({ name: 'Select a State', abbreviation: '' });
      } else {
        $scope.selectState($scope.state);
      }
    });

    const userCommunicationListener = $scope.$watch(
      'userCommunication',
      () => {
        $scope.isCommunicationSaveDisabled =
          angular.equals($scope.communication, $scope.userCommunication) &&
          angular.equals($scope.sampleUserInfo, $scope.userInfo);
      },
      true, // force deepwatch for entire object comparison
    );

    const userInfoListener = $scope.$watch(
      'userInfo',
      () => {
        $scope.isCommunicationSaveDisabled =
          angular.equals($scope.communication, $scope.userCommunication) &&
          angular.equals($scope.sampleUserInfo, $scope.userInfo);
        $scope.isSubmitUserDataDisabled = angular.equals($scope.sampleUserInfo, $scope.userInfo);
      },
      true, // force deepwatch for entire object comparison
    );

    $scope.init();
    $scope.initValues();
    $scope.$on('$destroy', () => {
      $scope.unsubscribe();
      // unset attributes when destroying component
      $scope.clearUserAttributes();
      componentListener();
      userListener();
      countryListener();
      userCommunicationListener();
      userInfoListener();
    });
  })
  .directive('userEdit', () => {
    return {
      templateUrl: 'templates/v2/user-edit.html',
    };
  });
